// Alphabets spécifiques pour chaque langue
// Jours: 0=dimanche, 1=lundi, ..., 6=samedi
// Mois: 1=janvier, 2=février, ..., 12=décembre

// Saisons: hiver (déc-janv-févr), printemps (mars-avr-mai), été (juin-juil-août), automne (sept-oct-nov)
const SEASONS = {
  fr: ['Printemps', 'Été', 'Automne', 'Hiver'],
  en: ['Spring', 'Summer', 'Autumn', 'Winter'],
  de: ['Frühling', 'Sommer', 'Herbst', 'Winter'],
  es: ['Primavera', 'Verano', 'Otoño', 'Invierno'],
  it: ['Primavera', 'Estate', 'Autunno', 'Inverno'],
  pt: ['Primavera', 'Verão', 'Outono', 'Inverno'],
  tr: ['İlkbahar', 'Yaz', 'Sonbahar', 'Kış'],
  pl: ['Wiosna', 'Lato', 'Jesień', 'Zima'],
  ru: ['Весна', 'Лето', 'Осень', 'Зима'],
  uk: ['Весна', 'Літо', 'Осінь', 'Зима']
};

const DAYS_MONTHS = {
  fr: {
    days: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
  },
  en: {
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  },
  de: {
    days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
  },
  es: {
    days: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
  },
  it: {
    days: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
    months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
  },
  pt: {
    days: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
  },
  tr: {
    days: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
    months: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']
  },
  pl: {
    days: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień']
  },
  ru: {
    days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
  },
  uk: {
    days: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П\'ятниця', 'Субота'],
    months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень']
  }
};

export const languageAlphabets = {
  // Français - Alphabet latin standard + caractères spéciaux (accents)
  fr: {
    letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
    specialCharacters: 'àâäéèêëïîôùûüÿçœæ'.split(''),
    name: 'Français'
  },
  
  // Anglais - Alphabet latin standard
  en: {
    letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
    specialCharacters: [],
    name: 'English'
  },
  
  // Allemand - Alphabet latin + Ä, Ö, Ü, ß (les accents sont dans les lettres)
  de: {
    letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÜß'.split(''),
    specialCharacters: [],
    name: 'Deutsch'
  },
  
  // Espagnol - Alphabet latin + Ñ + accents
  es: {
    letters: 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZ'.split(''),
    specialCharacters: 'áéíóúü'.split(''),
    name: 'Español'
  },
  
  // Italien - Alphabet latin + accents
  it: {
    letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
    specialCharacters: 'àèéìòù'.split(''),
    name: 'Italiano'
  },
  
  // Portugais - Alphabet latin + lettres accentuées (dans letters)
  pt: {
    letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZÁÂÃÀÇÉÊÍÓÔÕÚ'.split('').filter((v, i, a) => a.indexOf(v) === i),
    specialCharacters: [],
    name: 'Português'
  },
  
  // Turc - Alphabet latin modifié (caractères spéciaux dans letters)
  tr: {
    letters: 'ABCÇDEFGĞHIİJKLMNOÖPRSŞTUÜVYZ'.split(''),
    specialCharacters: [],
    name: 'Türkçe'
  },
  
  // Polonais - Alphabet latin + lettres spéciales (dans letters)
  pl: {
    letters: 'AĄBCĆDEĘFGHIJKLŁMNŃOÓPRSŚTUWYZŹŻ'.split(''),
    specialCharacters: [],
    name: 'Polski'
  },
  
  // Russe - Alphabet cyrillique
  ru: {
    letters: 'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ'.split(''),
    specialCharacters: [],
    name: 'Русский'
  },
  
  // Ukrainien - Alphabet cyrillique ukrainien
  uk: {
    letters: 'АБВГҐДЕЄЖЗИІЇЙКЛМНОПРСТУФХЦЧШЩЬЮЯ'.split(''),
    specialCharacters: [],
    name: 'Українська'
  }
};

// Fonction pour obtenir l'alphabet d'une langue
export const getAlphabetForLanguage = (languageCode) => {
  return languageAlphabets[languageCode] || languageAlphabets.en;
};

// Chiffres universels (identiques pour toutes les langues)
export const universalNumbers = '0123456789'.split('');

// Fonction pour obtenir les lettres et chiffres selon la langue
export const getCharactersForLanguage = (languageCode) => {
  const alphabet = getAlphabetForLanguage(languageCode);
  const daysMonths = DAYS_MONTHS[languageCode] || DAYS_MONTHS.en;
  const seasons = SEASONS[languageCode] || SEASONS.en;
  return {
    letters: alphabet.letters,
    specialCharacters: alphabet.specialCharacters || [],
    numbers: universalNumbers,
    days: daysMonths.days,
    months: daysMonths.months,
    seasons,
    languageName: alphabet.name
  };
};

